import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/index'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import store from './store'
import './mixins/globalMixin'

Vue.use(ViewUI);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
